import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';

@Injectable({
	providedIn: 'root'
})
export class MoniecrmGuard implements CanActivate {

	constructor(
		private router: Router,
	) {
	}

	canActivate() {
		if (AppConfig.SHOW_MONIECRM) {
			return true;
		} else {
      this.router.navigateByUrl('/');
		}
	}
}
